import { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

let types = {
  square: 'square-selector',
  rect: 'rect-selector',
  pill: 'pill-selector',
  'small-pill': 'small-pill-selector',
  checkbox: 'checkbox-selector',
  radio: 'radio-selector',
};

class Option extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: false,
    };
  }

  onClick(optionKey) {
    let { onClick, actionIsPromise } = this.props;
    if (actionIsPromise) {
      this.setState({ showSpinner: true });
      onClick(optionKey)
        .then(() => {
          this.setState({ showSpinner: false });
        })
        .catch((e) => console.log(e));
    } else {
      onClick(optionKey);
    }
  }

  onKeyDown(e, optionKey) {
    if (e.keyCode === 13) {
      this.onClick(optionKey);
    }
  }

  render() {
    let { selected, options, optionKey, type, croppedImg } = this.props;
    if (!options[optionKey]) return null;

    let value = options[optionKey]['value'];
    let img = options[optionKey]['img'];
    let icon = options[optionKey]['icon'];
    let optionText = options[optionKey]['optionText'];
    let optionHTML = options[optionKey]['optionHTML'];
    let subtext = options[optionKey]['subtext'];

    let isSelected;
    if (selected !== null) {
      isSelected = Array.isArray(selected)
        ? selected.includes(value)
        : value === selected;
    }

    const optionClasses = clsx(
      'selector-option',
      types[type] || types['square'],
      { selected: isSelected }
    );

    const lowerCase = optionText.toLowerCase();
    return (
      <div
        role="button"
        tabIndex="0"
        data-testid={`option-${lowerCase}`}
        aria-label={lowerCase}
        className={optionClasses}
        key={`${value}-option`}
        onClick={() => this.onClick(value)}
        onKeyDown={(e) => this.onKeyDown(e, value)}
      >
        {icon ? (
          <span
            aria-hidden
            className="icon"
            dangerouslySetInnerHTML={{ __html: icon }}
          ></span>
        ) : null}
        {img && !croppedImg ? (
          <img alt="" data-testid={`option-${lowerCase}-image`} src={img} />
        ) : null}
        {img && croppedImg ? (
          <div
            data-testid={`option-${lowerCase}-image`}
            className="cropped-img"
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ) : null}
        {optionHTML && (
          <div
            className="option-text"
            dangerouslySetInnerHTML={{ __html: optionHTML }}
          ></div>
        )}
        {optionText && !optionHTML ? (
          <div className="option-text">{optionText}</div>
        ) : null}
        {subtext ? (
          <div
            className="option-subtext"
            dangerouslySetInnerHTML={{ __html: subtext }}
          ></div>
        ) : null}
        {this.state.showSpinner ? <span className="hr-loading"></span> : null}
      </div>
    );
  }
}

// optionsOrder is an array of keys which replaces optionsKeys
/**
 * @deprecated
 * @type {any}
 */
let Selector = ({
  selected,
  options,
  action,
  type,
  optionsOrder,
  croppedImg,
  actionIsPromise,
}) => {
  let containerClasses = clsx('options-container', {
    pills: type && type.includes('pill'),
  });
  let optionsKeys = optionsOrder ? optionsOrder : Object.keys(options);

  return (
    <div className={containerClasses}>
      {optionsKeys.map((key) => {
        return (
          <Option
            key={key}
            selected={selected}
            options={options}
            optionKey={key}
            onClick={action}
            type={type}
            croppedImg={croppedImg}
            actionIsPromise={actionIsPromise}
          />
        );
      })}
    </div>
  );
};

Selector.propTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
    PropTypes.array.isRequired,
    PropTypes.bool.isRequired,
  ]),
  options: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  type: PropTypes.string,
};

export default Selector;
